import { render, staticRenderFns } from "./TenancyNewDepositGuaranteeSuccess.vue?vue&type=template&id=55cc7501&"
import script from "./TenancyNewDepositGuaranteeSuccess.vue?vue&type=script&lang=js&"
export * from "./TenancyNewDepositGuaranteeSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports